import { STATUSPAGE } from '@repo/ui';
import { ExportActivitiesQuantityPerStudentUseCaseInterface } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import { loadFilters } from 'presentation/config/store/reports/activites-quantity-per-student-slice';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { IActivitiesQuantityPerStudentFilters } from '../models/activities-quantity-per-student-filters';

export const useActivitiesQuantityPerStudent = () => {
  // Hooks
  const dispatch = useDispatch();
  const { reportService } = useService();

  // States
  const { filters } = useAppSelector(
    (state) => state.activitiesQuantityPerStudent,
  );
  const [loading, setLoading] = useState<STATUSPAGE>(STATUSPAGE.DONE);
  const [selectedSubmitBtn, setSelectedSubmitBtn] = useState<string>();

  // Methods
  const requestHandleActivitiesQuantityPerStudent = useCallback(
    (params: ExportActivitiesQuantityPerStudentUseCaseInterface.Params) => {
      setLoading(STATUSPAGE.LOADING);
      reportService
        .exportActivitiesQuantityPerStudent(params)
        .then((res) => {
          if (!res?.url) {
            throw new Error('URL do relatório não foi retornada.');
          }

          if (params.type === 'pdf') {
            window.open(res.url, '_blank');
            return;
          }

          const link = document.createElement('a');
          link.href = res.url;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.click();
        })
        .catch((err) => {
          notifyError(err.message);
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
        });
    },
    [],
  );

  const saveFilters = useCallback(
    (params: IActivitiesQuantityPerStudentFilters) => {
      dispatch(loadFilters(params));
    },
    [],
  );

  return {
    // States
    filters,
    loading,
    selectedSubmitBtn,
    // Methods
    setLoading,
    saveFilters,
    setSelectedSubmitBtn,
    requestHandleActivitiesQuantityPerStudent,
  };
};
